import { Page, PageTitle } from '../../../components';
import { TenDayBuildsList } from './ten-day-builds-list';
import { useMediaQuery } from '@mui/material';

export const TenDayBuildsPage = () => {
  const removeStickyHeader = useMediaQuery('(max-width: 1246px)');

  return (
    <Page pageHasStickyHeaders={removeStickyHeader ? false : true} title="Ten Day Builds">
      <PageTitle title="Ten Day Builds" />
      <TenDayBuildsList />
    </Page>
  );
};
